import React from 'react';

import ActionPlanEmailCampaignMessage from './ActionPlanEmailCampaignMessage';
import { ParsedMessage } from './types';
import { formatDelay } from './utils';

type Props = {
  messages: ParsedMessage[];
  expandedMessageId: number | null;
  onToggleMessage: (messageId: number) => void;
  onEditMessage: (messageId: number) => void;
};

const ActionPlanEmailCampaignMessages = ({ messages, expandedMessageId, onToggleMessage, onEditMessage }: Props) => (
  <>
    {messages.map((message) => {
      const isExpanded = expandedMessageId === message.id;
      const delayLabel = formatDelay({
        delayEnabled: message.delayEnabled,
        delayDays: message.delayDays,
        delayHours: message.delayHours,
        delayMinutes: message.delayMinutes,
      });

      return (
        <ActionPlanEmailCampaignMessage
          key={message.id}
          delayLabel={delayLabel}
          subject={message.subject}
          content={message.content}
          isExpanded={isExpanded}
          onToggle={() => onToggleMessage(message.id)}
          onEdit={() => onEditMessage(message.id)}
        />
      );
    })}
  </>
);

export default ActionPlanEmailCampaignMessages;

